import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=3363b537&scoped=true&"
import script from "./GroupItem.vue?vue&type=script&lang=js&"
export * from "./GroupItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=3363b537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363b537",
  null
  
)

export default component.exports